import styled from "styled-components";
import { COLORS } from "../../../constants";

const CardTitle = styled.h4`
  color: ${COLORS.PRIMARY};
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0;
`;

export default CardTitle;